import { RoomId, roomId, RoomTitle, roomTitle } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomDeleteCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomDeleteCmd.validationSchema()
  );

  constructor(readonly value: RoomDeleteCmdRaw) {
    JsonSchemaValidator.assert(RoomDeleteCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "roomTitle"],
      properties: {
        roomId,
        roomTitle
      },
      additionalProperties: false
    };
  }
}

interface RoomDeleteCmdRaw {
  roomId: RoomId;
  roomTitle: RoomTitle;
}
